import { render } from "./CentTranslatedPrice.vue?vue&type=template&id=393c81f5&scoped=true"
import script from "./CentTranslatedPrice.vue?vue&type=script&lang=js"
export * from "./CentTranslatedPrice.vue?vue&type=script&lang=js"

import "./CentTranslatedPrice.vue?vue&type=style&index=0&id=393c81f5&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393c81f5"]])

export default __exports__